import { DictService } from 'app/services/dict.service';
import {
  clearFieldValue,
  getFormValue,
} from 'app/services/businessFunctionHelpers';

import { setMessageVisibility } from 'app/services/businessFunctionHelpers';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import { DictionariesEnum, FieldsEnum, FormsEnum } from 'app/shared/enums';
import { isZipCodeValid } from 'app/validators/validateZipCode';
import { ScrollService } from 'app/services/scroll.service';
import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

export function zipCodeChange(
  initialRun: boolean,
  zipCodeField: FieldsEnum,
  formName: FormsEnum = FormsEnum.CalculationForm
) {
  const value = getFormValue(zipCodeField, formName);

  if (!isZipCodeValid(value)) {
    return;
  }

  DictService.getDictionary('cities', { zipCode: value }).then(({ data }) => {
    setMessageVisibility({
      key: getMessageKeyWithSuffix(zipCodeField, 'invalid_zip_code'),
      visible: !data || !data.length,
      formName,
    });

    if (initialRun && (!data || !data.length)) {
      clearFieldValue(zipCodeField, formName, true);
    }

    if (!initialRun && data && data.length && isMobileOrTablet()) {
      setTimeout(() => ScrollService.scrollToQuestion(zipCodeField));
    }
  });
}

export function bankZipCodeChange(
  initialRun: boolean,
  zipCodeField: FieldsEnum,
  answersDictionaryKey: DictionariesEnum,
  formName: FormsEnum = FormsEnum.CalculationForm
) {
  const zipCode = getFormValue(zipCodeField, formName);

  if (!isZipCodeValid(zipCode)) {
    return;
  }
  DictService.getDictionary(answersDictionaryKey, { zipCode }).then(
    ({ data }) => {
      setMessageVisibility({
        key: getMessageKeyWithSuffix(zipCodeField, 'invalid_zip_code'),
        visible: !data.length,
        formName,
      });

      if (initialRun && (!data || !data.length)) {
        clearFieldValue(zipCodeField, formName, true);
      }
    }
  );
}
